import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Meme from './components/Meme';
// import Counter from './components/Counter'



ReactDOM.render(
   <Meme />,
  document.getElementById('root')
);


